import { render, staticRenderFns } from "./PropostaEditOperacao.vue?vue&type=template&id=069c4357"
import script from "./PropostaEditOperacao.vue?vue&type=script&lang=js"
export * from "./PropostaEditOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports